/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import TextWidget from './TextWidget';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';

export default function UppercaseTextFieldWidget(props) {
  const [value, setValue] = useState(props.value);
  const { uiSchema, rawErrors = [], rawHelp = [] } = props;

  const _onChange = (val) => {
    props.onChange(val?.toUpperCase());
    setValue(val?.toUpperCase());
  };

  const hasError = rawErrors?.length > 0 || uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'error';
  const hasWarning = rawHelp?.length > 0 && uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'info';

  return <TextWidget {...props} onChange={_onChange} value={value} hasError={hasError} hasWarning={hasWarning} />;
}
